var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import DirectionsCarFilledOutlinedIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { Colors } from "../../util/theme";
export var CardRedirectIpva = function () {
    var navigate = useNavigate();
    return (_jsxs(Button, __assign({ onClick: function () { return navigate("/veiculos/consulta-ipva"); }, sx: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        } }, { children: [_jsxs(Box, __assign({ display: "flex", alignItems: "center", gap: "1rem" }, { children: [_jsx(DirectionsCarFilledOutlinedIcon, { fontSize: "large", sx: { color: Colors.AZUL_GOV } }), _jsxs(Box, __assign({ display: "flex", flexDirection: "column", alignItems: "start" }, { children: [_jsx(Typography, __assign({ mt: 1, fontSize: "1rem", fontWeight: 500, sx: { color: "black" } }, { children: "Emitir IPVA" })), _jsx(Typography, __assign({ variant: "caption", color: "textSecondary" }, { children: "Realize a Emiss\u00E3o do IPVA do Ve\u00EDculo." }))] }))] })), _jsx(IconButton, __assign({ onClick: function () { return navigate("/veiculos/consulta-ipva"); } }, { children: _jsx(ArrowForwardIosOutlinedIcon, { sx: { color: "#757575" } }) }))] })));
};
